import React, { memo, useMemo } from 'react';
import classNames from 'classnames';
import NextImage from '$/components/NextImage';
import { IInlineBoxData, MarkOrderConfig, RenderMarkOrderNode } from '../../types';
import MarkOrder from '../MarkOrder';
import styles from './index.module.scss';
import { CONTAINER_PADDING, MAX_IMAGE_HEIGHT, MAX_IMAGE_WIDTH } from '../../constants';

/** 渲染 Mark 悬停预览，fitImageWidth 模式使用数据中的宽高预留稳定的图片区域。 */
function MessagePopoverContent({
  markElementInfo,
  renderMarkOrderNode,
  markOrderConfig,
  fitImageWidth = false,
}: {
  markElementInfo: IInlineBoxData;
  renderMarkOrderNode?: RenderMarkOrderNode;
  markOrderConfig?: MarkOrderConfig;
  fitImageWidth?: boolean;
}) {
  /** 原图像素 → 容器坐标（唯一真源） */
  const position = useMemo(() => {
    const x = markElementInfo.point?.x || 0;
    const y = markElementInfo.point?.y || 0;

    const width = markElementInfo.width || 112;
    const height = markElementInfo.height || 112;

    const ratio = width / height;

    // 根据长宽比自适应容器尺寸
    let containerWidth: number;
    let containerHeight: number;

    if (ratio > 1) {
      // 宽大于高：固定宽度112，高度自适应
      containerWidth = MAX_IMAGE_WIDTH; // 112
      containerHeight = MAX_IMAGE_WIDTH / ratio;
    } else {
      // 高大于宽：固定高度152，宽度自适应
      containerHeight = MAX_IMAGE_HEIGHT; // 152
      containerWidth = MAX_IMAGE_HEIGHT * ratio;
    }

    return {
      left: x * containerWidth,
      top: y * containerHeight,
      width: containerWidth,
      height: containerHeight,
    };
  }, [markElementInfo]);

  const renderMarkOrder = () => {
    if (markElementInfo.order) {
      if (renderMarkOrderNode) {
        return renderMarkOrderNode(markElementInfo.order);
      }
      return (
        <MarkOrder order={markElementInfo.order} markOrderConfig={markOrderConfig} />
      );
    }
    return null;
  };

  const previewWidth = fitImageWidth
    ? markElementInfo.width || MAX_IMAGE_WIDTH
    : position.width;
  const previewHeight = fitImageWidth
    ? markElementInfo.height || MAX_IMAGE_WIDTH
    : position.height;

  return (
    <div
      className={styles['message-popover-content']}
      style={{
        width: previewWidth + CONTAINER_PADDING * 2,
        height: previewHeight + CONTAINER_PADDING * 2,
      }}
    >
      <div
        className={classNames(styles['message-popover-zoom-container'], {
          [styles['message-popover-zoom-container-fit-width']]: fitImageWidth,
        })}
        style={{ height: previewHeight }}
      >
        <div
          className={styles['message-popover-content-image']}
          style={{
            transformOrigin: position
              ? `${position.left}px ${position.top}px`
              : undefined,
          }}
        >
          <NextImage
            className={styles.img}
            src={markElementInfo.url}
            alt=""
            width={fitImageWidth ? previewWidth : undefined}
            height={fitImageWidth ? previewHeight : undefined}
          />
        </div>
        {markElementInfo.order && markElementInfo.showOrder !== false && position ? (
          <div
            className={styles['message-mark-order-container']}
            style={{
              left: `${position.left}px`,
              top: `${position.top}px`,
            }}
          >
            {renderMarkOrder()}
          </div>
        ) : null}
      </div>

    </div>
  );
}
export default memo(MessagePopoverContent);
